import { reactive } from "vue";

export const confirmState = reactive({
    visible: false,
    title: "",
    message: "",
    confirmText: "Aceptar",
    cancelText: "Cancelar",
    type: "warning",
});

let pendingResolve = null;

// Muestra el modal de confirmación y devuelve una promesa: true = aceptar, false = cancelar
export function confirmDialog(options = {}) {
    if (pendingResolve) pendingResolve(false);

    confirmState.title = options.title || "Advertencia";
    confirmState.message = options.message || "";
    confirmState.confirmText = options.confirmText || "Aceptar";
    confirmState.cancelText = options.cancelText || "Cancelar";
    confirmState.type = options.type || "warning";
    confirmState.visible = true;

    return new Promise((resolve) => {
        pendingResolve = resolve;
    });
}

export function resolveConfirm(result) {
    confirmState.visible = false;
    if (pendingResolve) {
        pendingResolve(result);
        pendingResolve = null;
    }
}
